<template>
  <div>
    <div v-if="isClient" class="clientFoot">
      <!-- <footer>Copyright &copy; {{new Date().getFullYear()}} The DRL Group. All Rights Reserved.</footer> -->
      <footer>
        <p>
          Securities offered through NewEdge Securities, LLC, member FINRA and SIPC. The DRL Group is not a subsidiary or control affiliate of NewEdge Securities, LLC. NewEdge Securities, Inc. has no affiliation to BondDesk Trading LLC or BondTrader Pro, or Tradeweb Direct, Bondpoint, TMC, Market Axess or any ECN.<br><br>
          Do not buy discount bonds based on the Yield-to-Call (YTC). Yield to call (YTC) is not indicative of total return; this yield is valid only if the security is called. Bonds may or may not be called, or be callable on multiple dates or, in other cases, called any date following the first call date, so yield to call is based on the earliest stated call date. Discounted bonds may be subject to capital gains tax. Bonds may be subject to OID (Original Issue Discount). Bonds could also be subject to the DeMinimis Rule, please consult your tax advisor for further clarification. Insured bonds are issued for timely payment of principal and interest only. Insured bonds do not cover potential market loss and are subject to the claims paying ability of the insurance company. Municipal income may be subject to state, local, and Alternative Minimum Tax (AMT) taxation. Corporate and Municipal securities are subject to gains/losses based on the level of interest rates, market conditions, and credit quality of the issuer. Non-rated (NR), With-Drawn (WR), or below investment grade bonds, and lower-rated bonds carry a greater potential risk of default and should be considered by sophisticated investors only.<br><br>
          Prices and availability may change at any time without notice. The securities described herein may not be eligible for sale in all jurisdictions or to specific categories of investors.<br><br>
          This summary is for informational purposes only and is not an offer or solicitation for the purchase or sale of any security or a recommendation or endorsement of any security or issuer. NewEdge Securities, LLC. and DRL Group make no representation about the accuracy, completeness, or timeliness of this information.<br><br>
          This report does not regard any recipient's specific investment objectives, financial situation, or needs and is based on information obtained from sources believed to be reliable. No independent verification has been made, nor is its accuracy or completeness guaranteed. Opinions expressed herein are subject to change without notice. The division, group, subsidiary, or affiliate of NewEdge Securities, LLC, is under no obligation to update or keep the information current. NewEdge Securities, LLC accepts no liability for any loss or damage of any kind arising out of the use of this report. Contact your tax advisor regarding the suitability of tax-exempt investments in your portfolio. This document is for informational purposes only and does not replace or serve as a substitute for your official monthly statement generated by NFS. Please refer to your official statement for accurate and comprehensive account details.<br><br>
          Reminder: E-mails sent through the internet are not secure. Do not use e-mail to send us personal confidential information. Do not e-mail time sensitive instructions or trade orders. This e-mail is not an official trade confirmation for transactions executed in your account. Your e-mail message is not private; it is subject to review by the firm, its officers, agents, and employees. Unless expressly stated in this e-mail, nothing in this message should be construed as a digital or electronic signature.
        </p>
      <div class="mt-3">
        <div class="row align-items-center justify-content-lg-between">
          <div class="col-lg-6">
            <div class="copyright text-center  text-lg-left  text-muted">
              Copyright &copy; {{new Date().getFullYear()}} DRL Group. All Rights Reserved.
              <!-- &copy; {{new Date().getFullYear()}} <a href="https://www.drlgroup.net/" class="font-weight-bold ml-1" target="_blank">DRL Group - TRADEBOOK</a> -->
            </div>
            
          </div>
          <div class="col-lg-6">
            <ul class="nav nav-footer justify-content-center justify-content-lg-end">
              <li class="nav-item">
                <a href="https://www.drlgroup.net/privacy-policy" class="nav-link cursor-pointer" target="_blank">Privacy Policy</a>
               
              </li>
            </ul>
          </div>
        </div>
      </div>
      </footer>
      
    </div>
    <div v-else>
      <footer class="footer">
      <div class="container-fluid">
        <div class="row align-items-center justify-content-lg-between">
          <div class="col-lg-6">
            <div v-if="tenantName != 'Cline'" class="copyright text-center  text-lg-left  text-muted">
              Copyright &copy; {{new Date().getFullYear()}} DRL Group. All Rights Reserved.
              <!-- &copy; {{new Date().getFullYear()}} <a href="https://www.drlgroup.net/" class="font-weight-bold ml-1" target="_blank">DRL Group - TRADEBOOK</a> -->
            </div>
            <div v-if="tenantName == 'Cline'" class="copyright text-center  text-lg-left  text-muted">
              Copyright &copy; {{new Date().getFullYear()}} The Cline Financial Group. All Rights Reserved.
              <!-- &copy; {{new Date().getFullYear()}} <a href="https://www.drlgroup.net/" class="font-weight-bold ml-1" target="_blank">DRL Group - TRADEBOOK</a> -->
            </div>
          </div>
          <div class="col-lg-6">
            <ul class="nav nav-footer justify-content-center justify-content-lg-end">
              <li class="nav-item">
                <a v-if="tenantName != 'Cline'" href="https://www.drlgroup.net/privacy-policy" class="nav-link cursor-pointer" target="_blank">Privacy Policy</a>
                <a v-if="tenantName == 'Cline'" data-toggle="modal" data-target="#privacy"  class="nav-link cursor-pointer">Privacy Policy</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
        <!--Privacy Policy Modal -->

        <div
          class="modal fade"
          id="privacy"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Privacy Policy</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <img src="https://bidside-logos.s3.amazonaws.com/Cline.png" class="navbar-brand-img cline-logo"><br><br>

              <h5>Mid Atlantic Capital Corporation (MACC), as your broker-dealer, is committed to protecting your privacy and maintaining the confidentiality and security of your personal information.<br>
                We do not disclose nonpublic personal information about our present or former clients/investors to third parties other than as described below:<br></h5>
 
                <p class="text-left">We collect information about you (such as your name, address, social security number, assets and income) from our discussions with you, from documents that you may deliver to us and in the course of providing services for you. We may use this information to provide services to you, to open an account for you, to process a transaction for your account, or otherwise in furtherance of our business. In order to service your account and effect your transactions, we may provide your personal information to our affiliates and to firms that assist us in servicing your account and have a need for such information, such as a broker or fund administrator or financial advisor. We may also disclose such information to service providers and to financial institutions with whom we have joint marketing arrangements, but we require them to protect the confidentiality of your information and to use the information only for the purposes for which we disclose it to them. We do not otherwise provide information about you to outside firms, organizations or individuals, except to our attorneys, accountants and auditors and as permitted by law.<br><br>
 
                We restrict access to nonpublic personal information about you to internal personnel and affiliates who need to know the information to perform their job responsibilities and to conduct and process your business in an accurate and efficient manner. We maintain physical, electronic and procedural safeguards that comply with federal standards in order to protect your personal information.<br><br>
 
                California residents only: Your non-public personal information will not be shared with non-affiliated third parties. Please note that this does not apply if we need to disclose the information to effect, service, administer or process a transaction, product or service you have authorized or requested; to protect against fraud, liability or damages to property; to respond to judicial process; in connection with settling a transaction; or as otherwise permitted by law.<br><br>

                Securities are offered through Mid Atlantic Capital Corporation (MACC), a registered Broker Dealer, Member FINRA & SIPC. The Cline Financial Group is not a registered entity or a subsidiary or control affiliate of SIPC. The  Cline Financial Group is not a registered entity or a subsidiary or control affiliate of MACC. This is not an offer to sell securities in any other state or jurisdiction.  Cline Financial Group and Mid Atlantic Capital Corporation are not affiliated with Advisorwebsites.com.<br><br>

                Bonds are subject to market and credit risk of the company as well as interest rate risk and may be worth less than the principal amount is sold prior to maturity. Bonds may be subject to AMT, state or local income tax depending on residence. Please consult with your tax advisor. Discount bonds may be subject to capital gains tax. Prices and availability may change at any time without notice. Insured bonds do not cover potential market loss and are subject to the claims-paying ability of the insurance company.<br><br>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tenantName : null,
      isClient : this.isClientRoute(),
    };
  },
  watch: {
    $route() {
      this.isClient = this.isClientRoute();
    }
  },
  methods: {
    isClientRoute() {
      return window.location.pathname.includes('client');
    }
  },
  created() {
      this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
        }
      });
  }
    
}
</script>

<style scoped>
.clientFoot {
    z-index: 1000;
    color: #cbd5e1;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    padding: 10px 20px;
}

.clientFoot footer,
.clientFoot footer p {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
}
</style>